import api from '.';
import logger from '../utils/logger';
import { UpdateUserPreferencesResponse, UserPreferences } from '../types/user-preferences';

const urlPrefix = '/rental-cart-service';
export const getUserPreferences = async (
  companyId: number,
  userId: number,
): Promise<UserPreferences> => {
  try {
    const { data } = await api.get(
      `${urlPrefix}/companies/${companyId}/user/${userId}/rental-preferences`,
    );
    return data;
  } catch (error) {
    logger('error', 'at getUserPreferences while fetching user preferences');
    throw new Error('error at getUserPreferences while fetching user preferences');
  }
};

export const putUserPreferences = async (
  companyId: number,
  userId: number,
  requestBody: UserPreferences,
): Promise<UpdateUserPreferencesResponse> => {
  try {
    const { data } = await api.patch(
      `${urlPrefix}/companies/${companyId}/user/${userId}/rental-preferences`,
      requestBody,
    );
    return data;
  } catch (error) {
    logger('error', 'at putUserPreference while updating user preferences');
    throw new Error('error at putUserPreference while updating user preferences');
  }
};
